import React, { useState } from 'react'
import './Drawer.css'

export function Drawer(props) {



	const [title, setTitle] = useState((typeof props.title !== 'undefined') ? props.title : '')
	const [modal_close_btn_showed, setmodal_close_btn_showed] = useState((typeof props.hideCloseBtn !== 'undefined' && props.hideCloseBtn === true) ? false : true)
	const [modal_close_btn_value, setmodal_close_btn_value] = useState('Close')
	const [hasCloseButton, sethasCloseButton] = useState((typeof props.hasCloseButton !== 'undefined') ? props.hasCloseButton : true)
	const [fixedWidthWindow, setfixedWidthWindow] = useState((typeof props.fixedWidthWindow !== 'undefined') ? props.fixedWidthWindow : '')
	const [isDisplay, setisDisplay] = useState((typeof props.isDisplay !== 'undefined' && props.isDisplay === true) ? true : false)
	 

	const closeModal = (event) =>  {
		 
		return props.closeModal(event) 
	}
 
		 
	return (
		<div 
			className={`drawer-modal fade ${props?.isDisplay === true ? 'active' : ''} ${fixedWidthWindow}`} 
			id="model-right"
             >
			<div className="modal-dialog">
				{
					hasCloseButton && 
					<button 
						title={modal_close_btn_value} 
						type="button" 
						aria-label="Close" 
						className="close" 
						onClick={closeModal} >
						<svg viewBox="0 0 24 24" fill="none" width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path d="M18 6L6 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path><path d="M6 6L18 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path></svg>
					</button>
				}
				<div className="modal-content">
					<div className="modal-header">
						<h2>{title}</h2>
					</div>
					<div className={`modal-body ${props.hasFixedFooter === true ? '' : 'nofixedfooter'}`}>{props?.children}</div>
				</div>
			</div>
		</div>
	)
	 
}
